/**
 *  @class
 *  @function CollectionShowcase
 */

if (!customElements.get("collection-showcase")) {
  class CollectionShowcase extends HTMLElement {
    constructor() {
      super();

      this.images = this.querySelectorAll(".collection-showcase__img");
      this.collapsibleRows = this.querySelectorAll(
        "collapsible-row[data-group-id='collection-showcase-collapsible-row']",
      );
    }
    connectedCallback() {
      this.collapsibleRows.forEach((row) => {
        row.addEventListener("toggle", (event) => {
          this.collapsibleRows.forEach((row) => {
            if (
              row.getAttribute("data-collapsible-row-id") !== event.detail.id
            ) {
              row.shrink(0);
            }
          });

          if (event.detail.open) {
            this.images.forEach((image) => {
              if (image.getAttribute("data-block-id") === event.detail.id) {
                image.classList.add("active");
              } else {
                image.classList.remove("active");
              }
            });
          }
        });
      });
    }
  }
  customElements.define("collection-showcase", CollectionShowcase);
}
